module.exports = __webpack_public_path__ + "static/media/hz1.b83af1b2.png";